if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      
      const freeShippingThreshold = Math.round(Number(this.getAttribute('data-free-shipping')) * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      const cartTotal = Number(this.getAttribute('data-cart-total'));
      const freeShippingRemaining = cartTotal - freeShippingThreshold;
			
      let cartSliderWidth = 0;
      if ( freeShippingRemaining < 0 ) {
        this.querySelector('[data-js-free-shipping-text]').innerHTML = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', KROWN.functions.formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format) + KROWN.settings.iso_code);
        cartSliderWidth = 100 - (Math.abs(freeShippingRemaining) * 100 / freeShippingThreshold);
      } else {
        this.querySelector('[data-js-free-shipping-text]').innerHTML = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        cartSliderWidth = 100;
      }
			if ( this.querySelector('[data-js-free-shipping-slider]') ) {
				this.querySelector('[data-js-free-shipping-slider]').style.width = `${cartSliderWidth}%`;
			}

    }

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}


// ---------------------------------------------------------------------------
// StickerNotice — jauge palier cadeau plaquette de stickers (adapté v4)
// ---------------------------------------------------------------------------
if ( typeof StickerNotice !== 'function' ) {

  class StickerNotice extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      const threshold = Math.round(
        Number(this.getAttribute('data-sticker-threshold')) *
        (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1)
      );
      const cartTotal = Number(this.getAttribute('data-cart-total'));
      const remaining = cartTotal - threshold;

      const textEl   = this.querySelector('[data-js-sticker-notice-text]');
      const sliderEl = this.querySelector('[data-js-sticker-notice-slider]');

      // Le bloc aperçu (image stickers) est un frère de <sticker-notice>, pas un enfant
      const wrapper   = this.closest('.kt-sidebar__inner-element, .kt-cart__subtotal-widget');
      const previewEl = wrapper ? wrapper.querySelector('[data-js-sticker-gift-preview]') : null;

      if ( !textEl ) return;

      const locales = (window.KROWN && KROWN.settings && KROWN.settings.locales) || {};
      let sliderWidth = 0;
      let eligible = false;

      if ( remaining < 0 ) {
        const remainingFormatted = this.formatMoney(Math.abs(remaining));
        const tpl = locales.sticker_notice_remaining_to_gift
          || 'Plus que {{ remaining_amount }} pour recevoir votre plaquette de stickers offerte !';
        textEl.innerHTML = tpl.replace('{{ remaining_amount }}', remainingFormatted);
        sliderWidth = 100 - (Math.abs(remaining) * 100 / threshold);
      } else {
        textEl.innerHTML = locales.sticker_notice_gift_eligible
          || '🎉 Votre plaquette de stickers offerte est dans votre commande !';
        sliderWidth = 100;
        eligible = true;
      }

      if ( sliderEl ) {
        sliderEl.style.width = `${Math.max(0, Math.min(sliderWidth, 100))}%`;
      }

      if ( previewEl ) {
        previewEl.style.display = eligible ? 'flex' : 'none';
      }

    }

    formatMoney(cents) {
      const iso = (KROWN.settings && KROWN.settings.iso_code) ? KROWN.settings.iso_code : '';
      if ( KROWN.functions && typeof KROWN.functions.formatMoney === 'function' ) {
        return KROWN.functions.formatMoney(cents, KROWN.settings.shop_money_format) + iso;
      }
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

  }

  if ( typeof customElements.get('sticker-notice') == 'undefined' ) {
    customElements.define('sticker-notice', StickerNotice);
  }

}